import React from 'react';
import { numberUtils } from '@indico-data/utils';
import { StyledPagination } from './Pagination.styles';
export function Pagination(props) {
    //   renderPreviousPages = (currentPage, lastPage) => {
    //     if (currentPage === lastPage - 2) {
    //       return null
    //     }
    //     // this.props.getPage(endCursor, 1)
    //     if (currentPage === lastPage - 1) {
    //       return <>{lastPage - 2 >= 1 && <button onClick={() => this.props.getBeforePage(startCursor, )}>{lastPage - 2}</button>}</>
    //     }
    //     if (currentPage === lastPage) {
    //       return (
    //         <>
    //           {lastPage - 2 >= 1 && <button>{lastPage - 2}</button>}
    //           {lastPage - 1 >= 1 && <button>{lastPage - 1}</button>}
    //         </>
    //       )
    //     }
    //   }
    const { aggregateCount, hasNextPage, endCursor, startCursor } = props.pageInfo;
    const { currentPage, limit, quantity } = props;
    const lastPage = Math.ceil(aggregateCount / limit);
    const currentItemNumber = (currentPage - 1) * limit + 1;
    return (React.createElement(StyledPagination, { className: props.className, "data-cy": props['data-cy'], id: props.id },
        React.createElement("div", { className: "Pagination--stats" },
            React.createElement("p", null,
                "Showing",
                ' ',
                aggregateCount === 0 ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
                    currentItemNumber,
                    " - ",
                    currentItemNumber + quantity - 1,
                    " of",
                    ' ')),
                numberUtils.numberWithCommas(aggregateCount),
                " entries")),
        aggregateCount > limit && (React.createElement("div", { className: "Pagination--button-group", "data-cy": "Pagination--button-group" },
            React.createElement("p", { "data-cy": "pagination--label" }, "Page:\u00A0"),
            currentPage > 1 && (React.createElement("button", { onClick: () => props.getPreviousPage(startCursor) }, "Prev")),
            React.createElement("p", { "data-cy": "pagination--current-page" }, currentPage),
            lastPage > currentPage + 1 && (React.createElement("button", { onClick: () => props.getPage(endCursor, 1), "data-cy": "pagination--second-page-number" }, currentPage + 1)),
            lastPage > currentPage + 2 && (React.createElement("button", { onClick: () => props.getPage(endCursor, 2), "data-cy": "pagination--third-page-number" }, currentPage + 2)),
            lastPage > currentPage + 3 && (React.createElement("button", { onClick: () => props.getPage(endCursor, 3) }, currentPage + 3)),
            lastPage - (currentPage + 2) === 3 && (React.createElement("button", { onClick: () => props.getPage(endCursor, 4) }, currentPage + 4)),
            lastPage - (currentPage + 2) > 2 && lastPage - (currentPage + 2) !== 3 && React.createElement("p", null, "..."),
            lastPage !== currentPage && (React.createElement("button", { onClick: () => props.getPage(endCursor, lastPage - currentPage), "data-cy": "pagination--last-page" }, lastPage)),
            hasNextPage && (React.createElement("button", { onClick: () => props.getNextPage(endCursor), "data-cy": "pagination--next-page-number" }, "Next"))))));
}
//# sourceMappingURL=Pagination.js.map